import { gql } from '../../generated'

export const READONLY_CUSTOM_FORM_PAGE_QUERY = gql(/* GraphQL */ `
  query ReadonlyCustomFormPage($appointmentChecklistInstanceId: uuid!) {
    appointmentChecklistInstancesByPk(
      appointmentChecklistInstanceGuid: $appointmentChecklistInstanceId
    ) {
      checklist
    }
  }
`)
